// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function RollupMissingInputMissingContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                ((rowContractData.comboStatus === '' || rowContractData.comboStatus === null )
                    && rowContractData.inputMissingRollup > 0 && rowContractData.inputMissingCount > 0 )
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="RollupMissingInputMissingContractAvatar"
                    >
                    <Avatar sx={{ml: 0, height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>{rowContractData.inputMissingCount}
                    </Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
